export const LOGO_URL = `${process.env.PUBLIC_URL}/plena-logo.png`;

export const PlenaMark = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" aria-hidden="true">
    <rect x="0" y="0" width="7" height="23" rx="3" fill="#EE6A5F" />
    <rect x="9.5" y="0" width="7" height="10" rx="3" fill="#F5C858" />
    <rect x="9.5" y="13" width="7" height="23" rx="3" fill="#3B8BF5" />
    <rect x="19" y="13" width="7" height="10" rx="3" fill="#3CC8A4" />
  </svg>
);

export const PlenaLogo = ({ height = 26, className = "" }) => (
  <img src={LOGO_URL} alt="Plena Pro" style={{ height }} className={`w-auto select-none ${className}`} draggable={false} />
);
